import { VIDEO_FILE_EXTENSION_REGEX } from 'components/flowBuilder/constants/files';
import VideoPlayer from './VideoPlayer';

export const isStaticVideoURL = (mediaUrl: string) =>
  mediaUrl.startsWith('http') && VIDEO_FILE_EXTENSION_REGEX.test(mediaUrl);

interface StaticVideoPreviewProps {
  url: string;
  poster?: string;
}

const StaticVideoPreview = ({
  url,
  poster,
}: StaticVideoPreviewProps): JSX.Element => {
  return <VideoPlayer url={url} maxHeight="300px" poster={poster} />;
};

export default StaticVideoPreview;
